const DEFAULT_AUTH_PARAMS = {
  source: '',
  client_id: '',
  response_type: '',
  redirect_uri: '',
};

const objectToQueryString = data =>
  Object.entries(data)
    .map(([param, value]) => `${param}=${value}`)
    .join('&');

var createLoginUrl = ({ myAccountUrl, loginUrl }, authParams, redirectTo = '') => {
  const redirectToState = encodeURIComponent(redirectTo);

  const redirectUri = encodeURIComponent(
    `${myAccountUrl}?${objectToQueryString({ state: redirectToState })}`
  );

  const params = {
    ...DEFAULT_AUTH_PARAMS,
    ...authParams,
    redirect_uri: redirectUri,
  };

  return `${loginUrl}?${objectToQueryString(params)}`;
};

export { createLoginUrl as default };
//# sourceMappingURL=create-login-url.js.map
